module.exports = "./img/f25f8b7a6d348f156362067de13dba7d.jpg";